// @flow

import React, { type Node } from 'react';
import { useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { RenderTotalDueDateAndCIP, RenderPaymentInstructions } from './pagoefectivo-page-components';
import { SaveCipCodeAsPdf } from './save-cip-as-pdf';
import { EmailVoucherMessage } from '../commons/email-voucher-message';
import {
  DashedHr,
} from '../../../organisms/shared-styled-components';

export function PagoEfectivoPage(): Node {
  const incomingPayment = useIncomingPayment();

  if(incomingPayment.status !== 'PE')
    throw new Error(`Pagoefectivo: invalid payment status ${incomingPayment.status}, it should be PE`);

  return (
    <>
      <EmailVoucherMessage
        headerMessage="Voucher generado!"
        textBeforeEmailAddress="Una copia del voucher fue enviada a"
        textAfterEmailAddress=", sin embargo, ya puedes pagar tu compra con los siguientes datos:"
      />
      <RenderTotalDueDateAndCIP />
      <SaveCipCodeAsPdf />
      <DashedHr />
      <RenderPaymentInstructions />
    </>
  );
}
